import { Button, IconButtonInverted } from "components/primitives";
import { Tooltip } from "react-bootstrap";
import styled from "styled-components";

export const ActionButtons = styled("div")`
  margin-bottom: 20px;
`;

export const EmptyText = styled("p")`
  color: #a9a9a9;
`;

export const ActionButton = styled(IconButtonInverted)`
  padding: 10px;
  width: 50px;
  height: 50px;
`;

export const Title = styled("div")`
  margin-bottom: 20px;
`;

export const WordsListBox = styled("div")`
  margin-bottom: 30px;

  > div:not(:last-child) {
    margin-bottom: 10px;
  }
`;

export const WordsItemBoxStyled = styled("div")`
  display: flex;
  width: 100%;
  gap: 10px;
  justify-content: space-between;
`;

export const WordName = styled(Button)<{ isActive: boolean }>`
  width: calc(100% - 47px); // btn and space
  box-shadow: none;
  background-color: var(--primary);
  opacity: ${(props) => (props.isActive ? "0.5" : 1)};
  color: white;
  padding: 10px;
  justify-content: space-between;

  > div {
    display: flex;
    align-items: center;
    gap: 5px;
    overflow-x: hidden;
    padding-right: 1px;

    svg {
      min-width: 15px;
    }

    span {
      text-align: left;
      display: block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
`;

export const WordDeleteBtn = styled(IconButtonInverted)`
  max-width: 50px;
  padding: 10px;

  svg {
    max-width: 17px;
    height: inherit;
  }
`;

export const TooltipStyled = styled(Tooltip)`
  z-index: 9999;
  font-weight: 600;
  opacity: 1 !important;

  .arrow:before {
    display: none;
  }

  .tooltip-inner {
    background-color: white;
    color: var(----widget-colour);
    text-align: left;
    box-shadow:
      rgba(0, 0, 0, 0.2) 0px 3px 3px -2px,
      rgba(0, 0, 0, 0.14) 0px 3px 4px 0px,
      rgba(0, 0, 0, 0.12) 0px 1px 8px 0px;
  }

  svg {
    margin-right: 5px;
    margin-bottom: 3px;
  }
`;
